var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoldova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003h-8.52v15.998H24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M8.52-.003H0v15.998h8.52V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M14.783 6.29H12.87a.87.87 0 10-1.74 0H9.218a.885.885 0 00.884.862.855.855 0 00.825.848.855.855 0 00.698.84l-.675 1.5c.333.136.69.205 1.05.203.36.001.717-.068 1.05-.203l-.675-1.5a.855.855 0 00.697-.84.855.855 0 00.856-.855.885.885 0 00.854-.855z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 7.475L10.867 8v1.042L12 9.74l1.132-.698V8L12 7.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M13.125 6.958h-2.258V8h2.258V6.958z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoldova);
export default __webpack_public_path__ + "static/media/Moldova.f2504ecc25f9e2f0334e8835429698c9.svg";
export { ForwardRef as ReactComponent };